export default "__VITE_ASSET__S2jntiYy__"